import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useProfileChartsDataContext } from './hooks/useProfileChartsDataContext';

export const StateOfBirth = () => {
    const { chartData } = useProfileChartsDataContext();

    return (
        <SimpleBars
            title={'Naturalidade (Top 5)'}
            horizontal={true}
            subtitles={chartData?.stateOfBirth?.map((item) => item.description)}
            values={chartData?.stateOfBirth?.map((item) => item.total  ||  0)}
            className="aligned-container"
        />
    );
};
